import axios from "axios";

const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } });
const limpar = (p) => Object.fromEntries(Object.entries(p).filter(([, v]) => v !== undefined && v !== null && v !== ""));

export async function carregarPromocoes(params) {
  const { data } = await axios.get("/api/reports/offers/promotions", { ...auth(), params: limpar(params) });
  return data;
}

export async function carregarPromocao(chave, params) {
  const { data } = await axios.get(`/api/reports/offers/promotions/${encodeURIComponent(chave)}`, { ...auth(), params: limpar(params) });
  return data;
}
